import { UploadIcon } from "../../constant/imagePath";

function BaseImport({ data }) {
  return (
    <button
      onClick={data?.onClick}
      className="h-8 min-w-[120px] px-4 bg-green-black-gradient flex items-center justify-center gap-x-2 font-extralight text-sm text-white hover:underline underline-offset-1 rounded-7 shadow-primary-inset"
    >
      <img src={UploadIcon} className="h-4" alt="Upload" />
      <span>Upload</span>
    </button>
  );
}

export default BaseImport;
